/**
 * Landing Page
 * The ultimate pet dental experience - "holy shit this is awesome"
 */

import React from 'react';
import Hero from '../components/Hero';
import DentalImportance from '../components/DentalImportance';
import Services from '../components/Services';
import Testimonials from '../components/Testimonials';
import Benefits from '../components/Benefits';
import Science from '../components/Science';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';

// New amazing components
import DentalHealthQuiz from '../components/DentalHealthQuiz';
import MeetTheTeam from '../components/MeetTheTeam';
import StickyBookingBar from '../components/StickyBookingBar';

const LandingPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Sticky mobile booking bar */}
      <StickyBookingBar />

      {/* Hero Section */}
      <Hero />

      {/* Interactive Dental Quiz - Engagement + Lead Gen */}
      <DentalHealthQuiz />

      {/* Why dental matters */}
      <DentalImportance />

      {/* Services & Pricing */}
      <Services />

      {/* Real Google Reviews */}
      <Testimonials />

      {/* Benefits of CHOMP */}
      <Benefits />

      {/* Meet the Team - Humanize the brand */}
      <MeetTheTeam />

      {/* Science & Research */}
      <Science />

      {/* FAQ */}
      <FAQ />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default LandingPage;
